import AddWalletScreen from 'features/believe/application/AddWalletScreen/AddWalletScreen';
import React from 'react';

export default function Page() {
  return <AddWalletScreen />;
}
